import React from "react";
// import {Link} from 'react-router-dom';
import './Header.css';



export default function Header() {
  return (
    <header className='header-container'>
      <h1 className='save-the-animals'>Save the Animals</h1>
        {/* <div className='nav-links'>

      <Link to='/dashboard'>My Campaigns</Link>
    
      <Link to='/add-campaign'>Add a New Campaign</Link>
      </div> */}
    </header>
  );
}
